import { WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOW } from '../../../../webcomponents.constants';
import { InProductTrialsOverlayContentWebComponent } from './component/InProductTrialsOverlayContentWebComponent';

export { InProductTrialsOverlayContentWebComponent };

window.customElements.define(WEB_COMPONENT_IN_PRODUCT_TRIALS_OVERLAY_WINDOW, InProductTrialsOverlayContentWebComponent);
